// URL base de la API (apiApp). Se define por entorno en .env.development / .env.production.
// Fallback = comportamiento histórico (API legacy) por si falta la variable.
export default process.env.VUE_APP_API_URL || "https://backoffice.cetae.com.ar/api/app/";
